import {forwardRef, useCallback, useEffect, useRef, useState} from "react";
import {
    calcTextAreaHeight, decodeDeeplink,
    formatDateCharDesc,
    generateUUID2,
    getImagePathWithTheme,
    getImagePathWithThemeSvg,
    isArray, isDeepLink,
    isNumberOrFloat, stringToDate, stringToDateOrNull
} from "@/utils";
import {getPropertyById, getPropertyByIds, getPropertyList, updateProperty} from "@model/Property";
import PopupDate from "@/views/Property/PopupDate";
import {Checkbox, Popover, Select, Tag, message } from "antd";
import {
    ARRAY_PROPERTY_OPTIONS_COLOR,
    EVENT_OPEN_LIBRARY_ITEM, EVENT_SHOW_DIALOG_DRAWINDEX,
    FROM_LIBRARY,
    getDefaultTagBackgroundColor, MAX_Z_INDEX
} from "@/Const";
import { t } from "i18next";
import {KEYS} from "../../../@excalidraw/packages/excalidraw/keys";
import CustomPropertySelect from "@/views/Property/CustomPropertySelect";
import {updateCard} from "@model/card";
import {updateProject} from "@model/note";
import {getViewListByTagNames} from "@model/view";
import {ipcInvoke, ipcSend} from "@/common/ipc";
import CustomDeeplink from "@/views/Property/CustomDeeplink";
import {postMessage} from "@/common/event";
import {deepLinkToLinkInfo, isSupportLink} from "@/Utility";
import {updateBoard} from "@model/board";

const DEFAULT_CONTENT_MIN_HEIGHT = 34;

const CustomPropertyInfo = forwardRef((props:{data:any},ref)=>{
    const [arrayCustomKeys,setArrayCustomKeys] = useState<any>([]);
    const mArrayPropertys = useRef(null);
    const [data,setData] = useState(props.data);
    const [openDatePicker,setOpenDatePicker] = useState<any>({});
    const [inputDate,setInputDate] = useState('');
    const [mapTextAreaStatus,setMapTextAreaState] = useState<any>({});
    const [mapTextAreaIsEditable,setMapTextAreaIsEditable] = useState<any>({});

    useEffect(() => {
        //这里还要处理下这个数据所关联的所有tag，及所有tag下的视图中的属性。。。
        //---来源太多太麻烦，比如这个data新增加了一个tag,或者删除了一个tag...在tag页处理的话，可能后面如果还有增加什么关联比较麻烦。在显示的时候处理
        setData(props.data);
    }, [props.data]);

    useEffect(() => {
        if (data){
            getViewListByTagNames(data?.tags).then(arrayViews=>{
                const arrayColumns:any = [];
                if (arrayViews){
                    for (let i=0;i<arrayViews.length;i++){
                        const tableView = arrayViews[i];
                        arrayColumns.push(...tableView.columns);
                        //每一个列...
                        for (let j=0;j<tableView.columns.length;j++){
                            const column = tableView.columns[j];
                            if (column.groupName == 'custom' && !data[column.id]){
                                //增加这个属性
                                if (column.type == 'select' || column.type == 'multiSelect'){
                                    data[column.id] = [];
                                    props.data[column.id] = [];
                                }else{
                                    data[column.id] = {
                                        type:column.type
                                    }
                                    props.data[column.id] = {
                                        type:column.type
                                    }
                                }
                            }
                        }
                    }
                }

                //取这些自定义的属性...
                const arrayKeys = Object.keys(data);
                const arrayCustom = arrayKeys.filter(p=>p.length > 30);
                //查询这些属性列
                getPropertyByIds(arrayCustom).then(async (r)=>{
                    const arrayPropertys:any = [];
                    const arrayExistCustom:any = [];

                    const szType = data.type || 'project';//没有type的就认为是project

                    const arrayDbPropertys = await getPropertyList();
                    //处理一下不存在的属性---可能已经被从属性管理里面删除了。。。
                    for (let i=0;i<arrayCustom.length;i++){
                        if (r[i] && arrayColumns.find(p=>p?.id == r[i]?.id)){
                            arrayPropertys.push(r[i]);
                            arrayExistCustom.push(arrayCustom[i]);
                        }else{
                            //如果这个属性没有关联这个类型，那么就删了。如果关联了就保持原样....
                            const property = arrayDbPropertys.find(p=>p.id == arrayCustom[i]);
                            const isRelated = property?.arrayRelatedType?.some(p=>p.value == szType);
                            if (!isRelated){
                                //被删除了..
                                delete data[arrayCustom[i]];
                                delete props.data[arrayCustom[i]];
                            }
                        }
                    }

                    //这里处理关联的属性....
                    for (let i=0;i<arrayDbPropertys.length;i++){
                        const property = arrayDbPropertys[i];
                        //处理选择
                        if (property.type == 'select' || property.type == 'multiSelect'){
                            const arraySelects = data[property.id];
                            const arrayNewSelects:any = [];
                            if (property && arraySelects){
                                for (let j=0;j<arraySelects.length;j++){
                                    if(property.items.some(p=>p.id == arraySelects[j].id)){
                                        arrayNewSelects.push(arraySelects[j]);
                                    }
                                }
                            }
                            data[property.id] = arrayNewSelects;
                        }

                        if (property?.arrayRelatedType){
                            const isRelated = property.arrayRelatedType.some(p=>p.value == szType);
                            if (isRelated){
                                if (!arrayPropertys.some(p=>p.id == property.id)){
                                    arrayPropertys.push(property);
                                    arrayExistCustom.push(property.id);
                                    //给这个数据补上这个属性...
                                    if (!data[property.id]){
                                        if (property.type == 'select' || property.type == 'multiSelect'){
                                            data[property.id] = [];
                                        }else{
                                            data[property.id] = {type:property.type}
                                        }
                                    }
                                }
                            }
                        }
                    }

                    mArrayPropertys.current = arrayPropertys;
                    setArrayCustomKeys(arrayExistCustom);
                })
            })
        }
    }, [data]);

    const getProperty = (id)=>{
        return mArrayPropertys.current?.find(p=>p?.id == id);
    }

    const updateProperty = (newData:any,key)=>{
        props.data[key] = newData[key];

        if (data.type == 'board'){
            updateBoard(newData).then(res=>{
                if (window.refresh_tableview_){
                    window.refresh_tableview_();
                }else{
                    window.globalRefreshList('refresh_gridview_')
                }
            })
        }
        else if (data.type && data.type != 'project'){
            updateCard(newData).then(res=>{
                if (window.refresh_tableview_){
                    window.refresh_tableview_();
                }else{
                    window.globalRefreshList('refresh_gridview_')
                }
            });
        }else{
            updateProject(newData).then(res=>{
                if (window.refresh_tableview_){
                    window.refresh_tableview_();
                }else{
                    window.globalRefreshList('refresh_gridview_')
                }
            });
        }
    }

    const calcPropertyInfoTextHeight = (key)=>{
        const textArea = document.createElement('textarea');
        const txt = document.getElementById(`txtarea-info-property-${key}`);
        if (!txt)return 30;
        textArea.id = 'txt-test-ssss-cr-h';
        textArea.classList.add('textarea-style-focus-border');
        textArea.style.width = (txt.offsetWidth || 322)+'px';
        textArea.style.fontSize = txt.style.fontSize;
        textArea.style.fontFamily = txt.style.fontFamily;
        textArea.innerHTML = data[key].text;
        textArea.style.position = 'fixed';
        textArea.style.zIndex = '999990';
        textArea.style.left = '0';
        textArea.style.top = '40px';
        textArea.style.paddingLeft = txt.style.paddingLeft;
        textArea.style.paddingRight = txt.style.paddingRight;
        textArea.style.paddingTop = txt.style.paddingTop;
        textArea.style.paddingBottom = txt.style.paddingBottom;
        textArea.style.resize = 'none';

        // textArea.style.overflowWrap ='anywhere';
        textArea.style.background = '#ff000000';
        // textArea.style.whiteSpace = 'pre';

        document.body.appendChild(textArea);

        textArea.style.height = '0px';
        // textArea.style.height = textArea.scrollHeight + 'px';
        let nHeight = textArea.scrollHeight;
        textArea.style.height = nHeight + 'px'
        document.body.removeChild(textArea);
        if (nHeight < 30){
            nHeight = 30;
        }
        return nHeight;
    }

    const isDeeplinkAndNoEdit = (key)=>{
        let isDeeplink = isDeepLink(data[key].text)
        return isDeeplink && !mapTextAreaIsEditable[key];
    }


    /**
     * 这里是内容...
     * @param key
     */
    const renderContent = (key)=>{
        const getBackgroundByStatus = ()=>{
            const szStatus = mapTextAreaStatus[key];
            if (!szStatus){
                return 'transparent';
            }
            if (szStatus == 'focus' || szStatus == 'blur' || szStatus == 'mouseLeave'){
                return 'transparent'
            }
            return 'var(--property-info-item-hover-color)';
        }
        const value = data[key];
        if (!value)return <></>
        if (value.type == 'text' || value.type == 'url' || value.type == 'number'){
            return <div className={''} style={{
                position: 'relative',
                width: '100%',
                marginTop: '0px',
                minHeight: '30px',
                display:'flex',
                height: mapTextAreaIsEditable[key] ? 'auto' : `${/*calcPropertyInfoTextHeight(key) + 0*/30}px`,
                maxHeight: '130px'
            }}>
                <textarea id={`txtarea-info-property-${key}`}
                          className={`${mapTextAreaIsEditable[key] ? '' : 'text-truncate-1'} ${mapTextAreaStatus[key] != 'focus' ? 'text-truncate-7' : ''}  textarea-style-focus-border ` + ((value.type == 'url' && data[key].text) ? 'url-link' : '')}
                          style={{
                              resize: 'none',
                              width: '100%',
                              display: isDeeplinkAndNoEdit(key) ? 'none' : '',
                              overflowY: (mapTextAreaStatus[key] == 'focus' || document.activeElement?.id?.includes('txtarea-info-property-')) ? 'auto' : 'hidden',
                              height: `${mapTextAreaIsEditable[key] ? calcPropertyInfoTextHeight(key) : 26}px`,
                              background: getBackgroundByStatus(),
                              maxHeight: '130px',
                              paddingTop: '6px',
                              margin: '2px 0 0 0'
                          }}
                          value={data[key].text || ''} placeholder={t("Empty")} onChange={(e) => {
                    const szValue = e.currentTarget.value;
                    if (data[key].type == 'number') {
                        if (szValue && !isNumberOrFloat(szValue)) {
                            return;
                        }
                    }
                    const newData = {...data};
                    newData[key].text = e.currentTarget.value;
                    setData(newData);
                    updateProperty(newData, key);
                }} onFocus={(e) => {
                    const newMap = {...mapTextAreaStatus};
                    newMap[key] = 'focus';
                    setMapTextAreaState(newMap);

                    const newMap0 = {...mapTextAreaIsEditable};
                    newMap0[key] = true;
                    setMapTextAreaIsEditable(newMap0);

                    if (isDeepLink(data[key].text)) {
                        const nLen = e.currentTarget.value.length;
                        e.currentTarget.setSelectionRange(nLen,nLen);
                        e.currentTarget.scrollTop = e.currentTarget.offsetHeight;
                    }
                }} onMouseEnter={(e) => {
                    const newMap = {...mapTextAreaStatus};
                    newMap[key] = 'mouseEnter';
                    setMapTextAreaState(newMap);
                }} onMouseLeave={(e) => {
                    const newMap = {...mapTextAreaStatus};
                    newMap[key] = 'mouseLeave';
                    setMapTextAreaState(newMap);
                }} onBlur={(e) => {
                    e.currentTarget.scrollTop = 0;
                    const newMap = {...mapTextAreaStatus};
                    newMap[key] = 'blur';
                    setMapTextAreaState(newMap);


                    const newMap0 = {...mapTextAreaIsEditable};
                    newMap0[key] = false;
                    setMapTextAreaIsEditable(newMap0);

                }} onKeyDown={(e)=>{
                    if (e.key == KEYS.ENTER){//哪里会处理这个enter ?????????????????????????????????????????? 找不到...
                        if (e.ctrlKey || e.metaKey){
                            let szTxt = e.currentTarget.value;
                            szTxt = szTxt + '\r\n';

                            const newData = {...data};
                            newData[key].text = szTxt;
                            setData(newData);

                            e.stopPropagation();
                        }else if (e.shiftKey){
                            e.stopPropagation();
                        }
                        else{
                            e.currentTarget.blur();
                        }
                    }
                    else if (e.key == KEYS.ESCAPE) {
                        e.currentTarget.blur();
                    }
                }}>
            </textarea>
                {
                    value.type == 'url' && <>
                        {
                            (isDeeplinkAndNoEdit(key)) ? <div className={'flex-row-vertical-center'}
                                                              style={{
                                                                  position: 'absolute',
                                                                  top: '8px',
                                                                  left: '7px',
                                                                  cursor: 'pointer',
                                                                  opacity: '1',
                                                                  marginRight: '16px',
                                                                  width:'calc(100% - 40px)'
                                                              }}>
                                    <CustomDeeplink url={data[key].text} onItemClick={() => {
                                        const newMap = {...mapTextAreaIsEditable};
                                        newMap[key] = true;
                                        setMapTextAreaIsEditable(newMap);

                                        setTimeout(() => {
                                            const input = document.getElementById(`txtarea-info-property-${key}`);
                                            if (input) {
                                                input.setSelectionRange(0, 0);
                                                input.focus();
                                            }
                                        }, 100)
                                    }}/></div> :
                                <span className={'span-single-line'} style={{
                                    position: 'absolute',
                                    top: '6px',
                                    left: '7px',
                                    cursor: 'pointer',
                                    opacity: '0',
                                    display: mapTextAreaIsEditable[key] ? 'none' : 'none'
                                }}
                                      onClick={(e) => {
                                          let szUrl = data[key].text;
                                          if (!szUrl.startsWith('http')) {
                                              szUrl = 'https://' + szUrl;
                                          }
                                          //打开链接
                                          ipcInvoke('open-url-withwhen', szUrl).then(res => {
                                              if (res == 'error') {
                                                  message.error(t("Open error"));
                                              }
                                          })
                                      }}>{data[key].text}</span>
                        }
                    </>
                    // !data[key].text && <span style={{position:'absolute'}}>{t("Empty")}</span>
                }

                {
                    value.type == 'url' && data[key].text &&
                    <img className={'img-16 cursor-pointer'}
                         style={{flexShrink: '0', marginTop: '8px', marginRight: '12px', marginLeft: 'auto'}}
                         src={getImagePathWithThemeSvg('link_open')} onClick={async () => {
                        let szUrl = data[key].text;
                        if (isDeepLink(szUrl)) {
                            window.closeInfo();
                            const deeplink = decodeDeeplink(szUrl);
                            if (deeplink.type == 'library' || deeplink.type == 'highlight') {
                                postMessage(EVENT_OPEN_LIBRARY_ITEM, {
                                    id: deeplink.id,
                                    from: FROM_LIBRARY,
                                    deeplink: deeplink,
                                    selectedId: deeplink.childId,
                                    inSlider: false,
                                })
                            } else {
                                //转到项目
                                const linkInfo: any = await deepLinkToLinkInfo(deeplink);
                                linkInfo.isLink = true;
                                postMessage(EVENT_SHOW_DIALOG_DRAWINDEX, {
                                    linkInfo: linkInfo,
                                    inSlider: false
                                });
                            }
                        } else {
                            if (isSupportLink(szUrl)) {
                                ipcInvoke('open-url-withwhen', szUrl)
                            } else {
                                if (!szUrl?.startsWith('http')) {
                                    szUrl = 'https://' + szUrl;
                                }
                                ipcSend('open-url', szUrl)
                            }
                        }
                    }}/>
                }
            </div>

        } else if (value.type == 'rating') {
            return <div className={'flex-row-vertical-center hovered-property-info-item'}
                        style={{
                            height: `${DEFAULT_CONTENT_MIN_HEIGHT}px`,
                            position: 'relative',
                            gap: '0 16px',
                            paddingLeft: '6px',
                            width: '100%'
                        }}>
                {
                    [...Array(5)].map((p, index) => {
                        return <img className={'img-16 cursor-pointer'}
                                    src={getImagePathWithThemeSvg(`column_rate${index < data[key]?.text ? '_selected' : ''}`)}
                                    onClick={(e) => {
                                        let szInput = index + 1;
                                        const newData = {...data};
                                        const newInputValue = {...newData[key]};
                                        if (newInputValue.text == szInput) {
                                            szInput = 0;
                                        }
                                        newInputValue.text = szInput;
                                        newData[key] = newInputValue;
                                        setData(newData);
                                        updateProperty(newData, key);
                                    }}/>
                    })
                }
            </div>
        } else if (isArray(value) || value.type == 'select' || value.type == 'multiSelect') {
            return <div className={'hovered-property-info-item'} style={{width: '100%',zIndex:`${MAX_Z_INDEX}`}}><CustomPropertySelect
                propertyId={key} selectOptions={data[key]} onSelectChanged={(arraySelectOptions:any)=>{
                const newData = {...data};
                newData[key] = arraySelectOptions;
                setData(newData);
                updateProperty(newData,key);
            }}/></div>
        }else if (value.type == 'checkbox'){
            return <div style={{paddingLeft:'6px',width:'100%',height:`${DEFAULT_CONTENT_MIN_HEIGHT}px`}} className={'flex-row-vertical-center hovered-property-info-item'} onClick={(e)=>{
                const newData = {...data};
                newData[key].text = !newData[key].text;
                setData(newData);
                updateProperty(newData,key);
            }}>
                <Checkbox checked={data[key].text} onChange={e=>{
                    const newData = {...data};
                    newData[key].text = e.target.checked;
                    setData(newData);
                    updateProperty(newData,key);
                }}/>
            </div>
        }else if (value.type == 'date'){
            return <div style={{width:'100%'}} className={''}><Popover arrow={false} align={{}} trigger={['click']}
                            open={openDatePicker[key]}
                                                                       overlayStyle={{zIndex:`${MAX_Z_INDEX}`}}
                            onOpenChange={(e)=>{
                                const newDate:any = {...openDatePicker};
                                newDate[key] = e;
                                setOpenDatePicker(newDate);
                            }}
                            placement={'bottomLeft'}
                            content={<PopupDate defaultDate={(data[key].text)}
                                                width={'334px'}
                                                from={'updateCustomProperty'}
                                                onDateSelect={(longDate, hasClose = true) => {
                                                    const newData = {...data};
                                                    newData[key].text = longDate;

                                                    const newDate = {...openDatePicker};
                                                    const arrayKeys = Object.keys(newDate);
                                                    for (let i=0;i<arrayKeys.length;i++){
                                                        newDate[arrayKeys[i]] = false;
                                                    }
                                                    setOpenDatePicker(newDate);

                                                    setInputDate(formatDateCharDesc(data[key].text));
                                                    updateProperty(newData,key);
                                                }}/>}>
                {/*<input readOnly={true} value={inputDate || formatDateCharDesc(data[key].text)} defaultValue={formatDateCharDesc(data[key].text)}*/}
                {/*       className={'nofocus-border'}*/}
                {/*       style={{width: '100%',padding:'0 8px',height:'30px',border:'none'}} onChange={(e)=>{*/}
                {/*    setInputDate(e.currentTarget.value);*/}
                {/*}}/>*/}
                <div style={{width:'100%',padding:'0 8px',height:`${DEFAULT_CONTENT_MIN_HEIGHT}px`}} className={'flex-row-vertical-center hovered-property-info-item'}>
                    {formatDateCharDesc(data[key].text)}
                    {!data[key].text && <span style={{color:'var(--input-place-holder-color)'}}>{t("Empty")}</span>}
                </div>
            </Popover>
            </div>
        }
        return <></>
    }

    return arrayCustomKeys.length ==0 ?<></>:<><div className={'line mt-12'} style={{margin: '12px -22px 12px -36px'}}></div>
        <div className={'default-font-size flex-col'}
             style={{/*overflow: 'auto', */gap: '6px 0px', /*maxHeight: '240px',*/ width: '100%',}}>
            {
                arrayCustomKeys.map(item => {
                    return <div>
                        <div className={'flex-row'} style={{alignItems: 'start',background:'transparent'}}>
                            <div className={'flex-row-vertical-center'}
                                 style={{flexShrink: '0', width: '140px', height: '30px'}}>
                                <img className={'img-16'} src={getImagePathWithThemeSvg(getProperty(item)?.icon)}/>
                                <span className={'ml-6 mt-1 span-single-line'}>{getProperty(item)?.name}</span>
                            </div>

                            <div className={'flex-row-vertical-center'} style={{flexGrow: '1', minHeight: '30px'}}>
                                {
                                    renderContent(item)
                                }
                            </div>

                        </div>
                    </div>
                })
            }
        </div></>
        })

export default CustomPropertyInfo;






































